module.exports = __webpack_public_path__ + "53dc4c90cd9a47501541d70a03ff7bf0.svg";